import { Data } from '../../../database.schema';
import { useFetchData } from '../tournament-data';

export const useFetchCourses = () => {
  return useFetchData((data: Data) => {
    return data.courses;
  });
};
